// Phase 1: canonical English translations for newly i18n-wrapped admin UI.
const en = {
  "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Enter an amount of at least 0.01 with up to two decimal places.",
  "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "You cannot transfer more than your available rakeback.",
  "레이크백을 일반 자산으로 이동했습니다.": "Rakeback has been transferred to your general asset balance.",
  "레이크백 이동에 실패했습니다.": "Failed to transfer rakeback.",
  "자산으로 이동": "Transfer to Assets",
  "레이크백 → 일반 자산": "Rakeback → General Assets",
  "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "The transferred amount is deducted from rakeback and added to general assets immediately.",
  "보유 레이크백": "Available Rakeback",
  "현재 일반 자산": "Current General Assets",
  "이동 금액": "Transfer Amount",
  "전액": "All",
  "이동 중...": "Transferring...",
  "소수 둘째 자리까지 입력 가능": "Up to two decimal places",
  "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Enter an amount from 0.01 to 1,000,000,000.00 with up to two decimal places.",
  "유저": "User",
  "디자인 이미지": "Design Image",
  "디자인": "Design",
  "실제 비율 미리보기": "Actual Ratio Preview",
  "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "Payment item amount must be greater than 0 and use no more than two decimal places.",
  "지급이 처리되지 않았습니다.": "The credit was not processed.",
  "차감이 처리되지 않았습니다.": "The debit was not processed.",
  "단독 인포버튼": "Standalone Info Button",
  "단독 인포버튼 생성 실패": "Failed to create standalone info button",
  "+ 인포버튼 단독 생성": "+ Create Standalone Info Button",
  "인포버튼 단독 생성": "Create Standalone Info Button",
  "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "Reset the current layout and multilingual copy to defaults?",
  "이미지 파일만 업로드할 수 있습니다.": "Only image files can be uploaded.",
  "배경 이미지 업로드에 실패했습니다.": "Failed to upload the background image.",
  "요소 이미지 업로드에 실패했습니다.": "Failed to upload the element image.",
  "이벤트 카드 디자인 · 광고 편집기 방식": "Event Card Design · Ad Editor Mode",
  "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Edit the event card itself using a background image, free positioning, image elements, and language-tagged text.",
  "기존 하이라이트 문구 불러오기": "Load Existing Highlight Copy",
  "디자인 초기화": "Reset Design",
  "새 디자인 사용": "Use New Design",
  "편집 디바이스": "Editing Device",
  "렌더링 방식": "Rendering Mode",
  "배경 + HTML/CSS 요소": "Background + HTML/CSS Elements",
  "이미지만 표시": "Image Only",
  "배경 이미지 맞춤": "Background Image Fit",
  "COVER · 영역 채우기": "COVER · Fill Area",
  "CONTAIN · 전체 표시": "CONTAIN · Show Entire Image",
  "FILL · 강제 맞춤": "FILL · Stretch to Fit",
  "배경 이미지": "Background Image",
  "업로드 중...": "Uploading...",
  "로컬 이미지 업로드": "Upload Local Image",
  "배경 제거": "Remove Background",
  "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "Uploading automatically fills /uploads/info-backgrounds/...",
  "요소 이미지 업로드 중...": "Uploading element image...",
  "배경 이미지 미리보기": "Background Image Preview",
  "입력 내용이 미리보기에 자동 반영됨": "Changes are automatically reflected in the preview.",
  "언어별 문구 적용 완료 · {count}개 언어 감지": "Language copy applied · {count} languages detected",
  "텍스트 {number}": "Text {number}",
  "이미지 파일만 업로드할 수 있어.": "Only image files can be uploaded.",
  "요소 이미지는 파일당 10MB 이하만 가능해.": "Each element image must be 10 MB or smaller.",
  "추가 텍스트": "Additional Text",
  "요소 이미지": "Element Image",
  "요소": "Element",
  "배너 레이아웃·다국어 편집": "Banner Layout · Multilingual Editor",
  "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Enter multilingual copy for each text element in one field, and add decorative local images separately from the background.",
  "클라이언트 언어별 미리보기": "Preview by Client Language",
  "미리보기: {language}": "Preview: {language}",
  "번역이 없을 때 사용할 언어": "Fallback language when a translation is missing",
  "기본: {language}": "Default: {language}",
  "편집 화면 {value}%": "Editor View {value}%",
  "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Drag elements on the enlarged canvas. Coordinates are stored as banner percentages so they scale with the window within the same device profile.",
  "텍스트 요소별 통합 다국어 입력": "Unified Multilingual Input by Text Element",
  "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "Use line breaks, |, or commas as separators. Example: Korean:지금 바로 | English:Right now | Japanese:今すぐ",
  "언어별 찾아서 적용": "Detect and Apply by Language",
  "한국어:문구 | 영어:Text | 일본어:テキ스트": "Korean:문구 | English:Text | Japanese:テキスト",
  "추가 텍스트 요소": "Additional Text Elements",
  "+ 텍스트 요소 추가": "+ Add Text Element",
  "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "No additional text elements. Add as many as needed.",
  "한국어:지금 바로 | 영어:Right now": "Korean:지금 바로 | English:Right now",
  "캔버스에서 이 텍스트 선택": "Select This Text on Canvas",
  "가로 중심": "Horizontal Center",
  "세로 중심": "Vertical Center",
  "확대": "Scale",
  "이미지 투명도": "Image Opacity",
  "텍스트 가독성 오버레이": "Text Readability Overlay",
  "요소 이미지 업로드": "Element Image Upload",
  "+ 로컬 이미지 추가": "+ Add Local Image",
  "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Add multiple logos, cards, chips, icons, and other images separately from the background, then adjust each position and size.",
  "이미지 요소": "Image Element",
  "기본 요소 선택": "Select Base Element",
  "{element} 위치·크기": "{element} Position · Size",
  "너비": "Width",
  "높이": "Height",
  "기준 글자 크기": "Base Font Size",
  "투명도": "Opacity",
  "회전": "Rotation",
  "정렬": "Alignment",
  "왼쪽": "Left",
  "가운데": "Center",
  "오른쪽": "Right",
  "글자색": "Text Color",
  "이미지 맞춤": "Image Fit",
  "전체 표시 · contain": "Show Entire Image · contain",
  "영역 채우기 · cover": "Fill Area · cover",
  "강제 맞춤 · fill": "Stretch to Fit · fill",
  "클라이언트에 표시": "Show on Client",
  "이 텍스트 요소 삭제": "Delete This Text Element",
  "이 이미지 요소 삭제": "Delete This Image Element",
  "프로필 좌표 복사": "Copy Profile Coordinates",
  "{profile}에서 복사": "Copy from {profile}",
  "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "The link must start with http://, https://, or / for an internal path.",
  "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Each saved row is a separate ad.",
  "배너 렌더링 방식": "Banner Rendering Mode",
  "배경 이미지 + 다국어 HTML/CSS 요소": "Background Image + Multilingual HTML/CSS Elements",
  "이미지 전체만 표시": "Display Full Image Only",
  "이미지 전체 표시 · contain": "Show Entire Image · contain",
  "https://... 또는 /lounge": "https://... or /lounge",
  "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Leave blank for no navigation · External URLs or internal paths such as /lounge are supported.",
  "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "In full-image mode, the uploaded image is displayed as-is. Coordinate and multilingual element editing is available in Background Image + HTML/CSS mode.",
  "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Each saved row is a separate ad · Managed separately by area/device/country.",
  "배지": "Badge",
  "제목": "Title",
  "보상": "Reward",
  "설명": "Description",
  "버튼": "Button",
  "배지 상단": "Badge Top",
  "배지 하단": "Badge Bottom",
  "강조 제목": "Accent Title",
  "보상 문구": "Reward Copy",
  "버튼 문구": "Button Copy",
};

const phase1Completion = { en };

export default phase1Completion;
